<template>
  <section class="contextual-area">
    <v-navigation-drawer
      id="menu-contextual"
      persistent
      mini-variant
      v-model="openMenu"
      enable-resize-watcher
      fixed
      clipped
      :right="right"
      app
      mini-variant-width="50"
      stateless
      class="accent contextual-menu"
      hide-overlay
      mobile-break-point="600"
      >
      <v-list class="menu-list py-0">
        <v-list-tile
          v-for="(menu, index) in itemsMenu"
          :key="menu.label"
          :aria-selected="menu.active"
          :to="{ name: menu.to.name }"
          @click="changeMenu(menu)"
          role="menu-item"
          ref="menu"
          :aria-label="menu.label"
          >
          <v-tooltip :ref="index" left>
            <template v-slot:activator="{ on }">
              <v-icon dark v-on="on">{{ menu.icon }}</v-icon>
            </template>
            <span>{{menu.label}}</span>
          </v-tooltip>
        </v-list-tile>
      </v-list>

    </v-navigation-drawer>

    <sidebar-content
      :temporary="false"
      :toolbar= "false"
      submitLabel="Enviar"
      hideSubmit
      :open="setOpen"
      @close="hideModal"
      :width="width"
      class="contextual-body"
      hasMenu
      :refs="menuActived"
      clipped
      hide-overlay
      floating
      touchless
      :permanent="false"
      mobile-break-point="600"
      >

      <h2 class="title">
        <v-btn icon
          title="Fechar"
          small
          color="bgColor"
          data-cy="close"
          @click="close">
          <v-icon color="accent">arrow_forward</v-icon>
        </v-btn>
       {{this.$route.meta.title}}
      </h2>
      <div id="area-scroll" v-resize="onResize" :style="setHeightScroll">
        <slot></slot>
      </div>
    </sidebar-content>

  </section>

</template>

<script>
  import SidebarContent from '@/components/ui/SidebarContent'
  import resizing from '@/utils/resizing'

  export default {
    mixins: [resizing],
    props: {
      itemsMenu: {
        type: Array,
        required: true
      },
      open: {
        type: Boolean
      },
      width: {
        type: [Number, String],
        default: 370
      },
      routeToClose: {
        type: Object,
        required: true
      }
    },
    components: { SidebarContent },
    data () {
      return {
        setOpen: null,
        showSidebar: false,
        right: true,
        rightDrawer: false,
        openMenu: true,
        menuActived: null
      }
    },
    methods: {
      hideModal () {
        this.$emit('close')
      },
      close () {
        this.setOpen = false
        let routeToClose = this.routeToClose

        let path = this.$route.path.split('/').slice(-1)
        if (path.length === 1) {
          this._removeClassMenu()
          this.$emit('close')
        }

        this.$nextTick(() => {
          this.$router.push(routeToClose)
        })
      },
      changeMenu () {
        this.$emit('change')
      },
      _removeClassMenu () {
        document.body.classList.remove('has-contextual-area')
      },
      _addClassMenu () {
        document.body.classList.add('has-contextual-area')
      }
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.xsOnly
      },
      setHeightScroll () {
        let heightCalc = this.windowSize.y - 100
        return `height: ${heightCalc}px; overflow-y: auto; margin-bottom: 20px`
      }
    },
    watch: {
      open (val) {
        this.setOpen = val
        val ? this._addClassMenu() : this._removeClassMenu()
      }
    },
    mounted () {
      this.$emit('menuActived', this.$route.name)
    },
    destroyed () {
      this._removeClassMenu()
    }
  }
</script>

<style lang="sass">
  // @import '../../assets/style/placeholder'
  @import '../../assets/style/variables'

  $width-contextual-menu: 50px //value default of miniVariantWidth prop
  $width-contextual-body: 370px //value default of width prop
  $spacer: 30px //value default of width prop

  .contextual-area

    .back-link
      position: absolute
      right: 16px
      top: 15px
      text-decoration: none
      color: $accent
      z-index: 2

      .v-icon
        color: $accent

      &:hover, &:focus, &:active
        color: $primary

        .v-icon
          color: $primary

    .container .v-table th.column
      padding: 8px

    // .empty-state,
    .loading
      margin-left: -25px
      margin-top: 25px

    .forced-flex
      flex-basis: 50%!important
      max-width: 50%!important

    .full-flex
      flex-basis: 100%!important
      max-width: 100%!important

    .show-discount
      padding-left: 0!important
      padding-right: 0!important

    .v-table__overflow
      // overflow: hidden!important

    .v-table td
      color: $textColor

    .table-list-opened
      border-bottom: none!important

    .title
      height: 48px
      font-weight: normal
      border-bottom: 1px solid lighten($mediumGray, 30%)
      text-overflow: ellipsis
      width: 100%
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      padding: 14px 12px 14px 45px
      position: relative
      color: $darkGray

      .v-btn
        position: absolute
        top: 5px
        left: 0

    .contextual-menu
      z-index: 7 //because mobile

      &.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close),
      &.v-navigation-drawer--temporary:not(.v-navigation-drawer--close)
        box-shadow: none

      .menu-list a

        &.v-list__tile--active
          background: $light

    // .has-contextual-menu
    //   width: calc(100% - #{$width-contextual-menu})!important
    //   max-width: 100%

    .contextual-body
      padding-right: $width-contextual-menu
      z-index: 6!important
      border-left: 1px solid lighten($mediumGray, 30%)
      // overflow: hidden
      width: 100%
      // width: calc(100% - #{$width-contextual-menu} - 20px)!important
      transform: translateX(100%)!important
      overflow: initial!important

      &.v-navigation-drawer--open
        transform: translateX(0)!important

      > .container
        padding: 0

  .has-contextual-area

    .v-btn--bottom.v-btn--floating.v-btn--fixed.v-btn--right
      // transform: translateX(-$width-contextual-menu)
      // z-index: 9
      z-index: 5

    main.v-content,
    .config-wrapper
      padding-right: $width-contextual-body!important

    .config-wrapper
      // padding-right: $width-contextual-menu!important
      transition: all .3s

    main.v-content .v-content__wrap
      padding-right: 0

    .v-btn--bottom.v-btn--floating.v-btn--fixed.v-btn--right
      transform: translateX(-$width-contextual-body)
      // z-index: 9

  #area-scroll
    // @extend %scroll
    width: 100%

    > .container
      position: relative
      height: 100%

  @media screen and (min-width: $max-mobile)
    .contextual-area
      .contextual-body
        width: $width-contextual-body!important

    .has-contextual-area
      main.content,
        padding-right: $width-contextual-body!important

      // .config-wrapper
      //   padding-right: $width-contextual-body!important
</style>
